import { useContext, useState } from "react";
import AppPrefContext from "../contexts/AppPrefContext";

export const AppPrefProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isOrderEntryOpenedFromMain, setIsOrderEntryOpenedFromMain] = useState<
    boolean | undefined
  >(undefined);
  const [isAppActive, setIsAppActive] = useState<boolean | undefined>(true);

  const value = {
    isOrderEntryOpenedFromMain,
    setIsOrderEntryOpenedFromMain,
    isAppActive,
    setIsAppActive,
  };

  return (
    <AppPrefContext.Provider value={value}>{children}</AppPrefContext.Provider>
  );
};

export const useAppPref = () => {
  const context = useContext(AppPrefContext);
  if (context === undefined) {
    throw new Error("useAppPref must be used within an AppPrefProvider");
  }
  return context;
};
